import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { EmployeeAvatar, MaybeTooltip } from '@modernloop/shared/components';
import { Stack } from '@mui/material';

import { MemberSelect_UserInfoFragment } from 'src/generated/mloop-graphql';

// eslint-disable-next-line modernloop/validate-component-definition.cjs
const MemberOption = ({
  currentEmployeeId,
  member,
}: {
  currentEmployeeId: string;
  member: MemberSelect_UserInfoFragment;
}) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing={1} alignItems="center" flexWrap="nowrap">
      <EmployeeAvatar
        imageUrl={member?.employee?.internalProfilePictureUrl}
        fullName={member.employee?.fullName}
        size={20}
      />
      <MaybeTooltip
        label={`${member.employee?.fullName}${
          member.employee?.id === currentEmployeeId ? t('hiring-dashboard-common:common.select.youSuffix') : ''
        }`}
        title={member.employee?.fullName || ''}
      />
    </Stack>
  );
};

export default MemberOption;
